import { Button, ButtonProps } from '@mui/material'
import { IconPlus } from '@tabler/icons-react'
import React from 'react'

const AddIconButton: React.FC<ButtonProps> = (props) => {
  return (
    <Button
      {...props}
      startIcon={<IconPlus height={'18px'} width={'18px'} stroke={2} />}
    />
  )
}

export default AddIconButton
